import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { moneyFlowService } from '../../../services'
import { parseHttpError } from '../../utils'
import { parseBillTypes } from './utils'
import { selectors } from './selectors'
import { TBillTypesState } from '../../types'
import { billTypesAdapter } from './adapter'

const name = 'billTypes'

const initialState: TBillTypesState = {
    ...billTypesAdapter.getInitialState(),
    isFetching: false
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async () => {
        return parseBillTypes(await moneyFlowService.fetchBillTypes())
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                billTypesAdapter.setAll(state, action.payload)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const billTypes = {
    name: slice.name,
    actions: {
        fetch,
    },
    reducer: slice.reducer,
    selectors,
}